import { useMemo } from 'react'
import { useDataFormat } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let is_patient = useDataFormat({
    context: 'referral',
    path: 'template.id',
    viewPath: props.viewPath,
    format: value => value === 'Patient',
  })

  return useMemo(() => {
    if (!data) return data

    let newData = data
      .filter(
        item =>
          !!item.person &&
          ((is_patient && item.person.patient) ||
            (!is_patient &&
              item.person.other_professional_relationships?.length > 0))
      )
      .map(item => {
        if (is_patient) {
          return {
            ...item.person,
            is_patient: true,
          }
        } else {
          let is_external_professional =
            item.person.other_professional_relationships?.length > 0

          let resourceName =
            item.person.other_professional_relationships?.[0].employee_type.name
          let location =
            item.person.other_professional_relationships?.[0].external_office

          return {
            ...item.person,
            is_patient: false,
            is_external_professional,
            resourceName,
            location,
          }
        }
      })
      .filter(Boolean)
    return newData
  }, [data, is_patient])
}
